import React, { useEffect, useState } from "react";

import { FaYoutube, FaFacebookSquare } from "react-icons/fa";

import { Link } from "react-router-dom";

import ApiCustom from "../utils/ApiCustom";

function Footer() {
  const [totalView, setTotalView] = useState(0);

  useEffect(() => {
    let ignore = false;

    ApiCustom.get("/views/total")
      .then((res) => {
        if (!ignore) setTotalView(res?.data?.data?.total ?? 0);
      })
      .catch(() => {
        if (!ignore) setTotalView(0);
      });

    return () => {
      ignore = true;
    };
  }, []);

  return (
    <div>
      <footer className="bg-base-200 text-base-content p-3 pt-4">
        <div className="container mx-auto max-w-[1580px] flex flex-col md:flex-row justify-between gap-6">
          <div className="flex flex-col min-w-[250px] mr-10">
            <p className="font-bold text-lg uppercase mb-2">
              Hội Xây Dựng TP Cần Thơ (CCA)
            </p>

            <h6 className="footer-title font-medium opacity-100 mb-2">
              Liên hệ
            </h6>

            <div className="link link-hover">
              Địa chỉ: 59 Hùng Vương, P. Ninh Kiều, Tp. Cần Thơ
            </div>

            <div className="link link-hover">
              Số điện thoại: 0907070359 (Ông Nguyễn Ngọc Thịnh - Chánh Văn phòng)
            </div>

            <div className="link link-hover">
              Website: hoixaydungcantho.org.vn
            </div>

            <div className="link link-hover">
              Email: hoixaydung.tpcantho@gmail.com
            </div>

            <div className="mt-4 lg:mt-16">
              <h6 className="footer-title font-medium opacity-100 mb-2">
                Chính sách
              </h6>

              <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-gray-600">
                <Link
                  to="/post/chinh-sach-bao-mat-thong-tin"
                  className="link link-hover"
                >
                  Chính sách bảo mật thông tin
                </Link>

                <Link
                  to="/post/chinh-sach-thanh-toan"
                  className="link link-hover"
                >
                  Chính sách thanh toán
                </Link>

                <Link
                  to="/post/chinh-sach-van-chuyen-va-giao-nhan"
                  className="link link-hover"
                >
                  Chính sách vận chuyển và giao nhận
                </Link>

                <Link
                  to="/post/dieu-kien-giao-dich-chung"
                  className="link link-hover"
                >
                  Điều kiện giao dịch chung
                </Link>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-6 min-w-[320px] flex-1">
            <nav>
              <h6 className="footer-title font-medium opacity-100 mb-2">
                Liên kết nhanh
              </h6>

              <div className="link link-hover mb-1">Giới thiệu</div>

              <div className="link link-hover mb-1">Hoạt động</div>

              <div className="ml-2 text-sm text-gray-600">
                <div className="link link-hover mb-1">Thăm doanh nghiệp</div>

                <div className="link link-hover mb-1">Cà phê doanh nhân</div>

                <div className="link link-hover mb-1">Đào tạo</div>

                <div className="link link-hover mb-1">Hoạt động khác</div>
              </div>
            </nav>

            <nav>
              <div className="link link-hover mt-8 mb-1">Sự kiện</div>

              <div className="ml-2 text-sm text-gray-600">
                <div className="link link-hover mb-1">Đăng ký sự kiện</div>

                <div className="link link-hover mb-1">Hình ảnh</div>

                <div className="link link-hover mb-1">Video</div>
              </div>

              <div className="mt-1">
                <div className="link link-hover mb-1">Tin tức</div>

                <div className="link link-hover">Liên hệ</div>
              </div>
            </nav>

            {/* <div className="md:col-span-2">
              <a
                href="http://online.gov.vn/Home/WebDetails/140838"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/da-thong-bao-BCT.png"
                  alt="Đã thông báo Bộ Công Thương"
                  className="h-auto max-h-[80px] w-auto object-contain"
                />
              </a>
            </div> */}
          </div>

          <div className="w-full md:max-w-[300px] flex flex-col items-center gap-3">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d20298.14629827564!2d105.77403200000002!3d10.04378!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a08900504eeb83%3A0xce1f6cb67b0c1560!2zSOG7mWkgWMOieSBE4buxbmcgVHAuIEPhuqduIFRoxqE!5e1!3m2!1sen!2sus!4v1778809597617!5m2!1sen!2sus"
              width="100%"
              height="180"
              style={{ border: 0 }}
              allowFullScreen=""
              title="gg Map"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>

            <div className="flex gap-4 mt-2">
              <a
                href="https://hoixaydung.katec.vn/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 hover:text-red-700"
              >
                <FaYoutube className="w-8 h-8" />
              </a>

              <a
                href="https://hoixaydung.katec.vn/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-700"
              >
                <FaFacebookSquare className="w-7 h-7" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <footer className="footer bg-base-200 text-base-content md:px-10 px-3 py-4">
        <aside className="container mx-auto max-w-[1580px] flex justify-between items-center">
          <p className="font-medium border-l-2 border-gray-500 pl-2">
            Vận hành bởi Hội Xây Dựng TP. Cần Thơ
          </p>

          <p className="text-sm text-gray-600">
            Số lượt ghé thăm:{" "}
            <span className="font-semibold">
              {Number(totalView || 0).toLocaleString("vi-VN")}
            </span>
          </p>
        </aside>
      </footer>

      <div className="bg-slate-100 text-center text-xs py-2 border-t border-slate-100">
        <a
          href="https://katec.vn"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 hover:text-blue-800 transition-colors"
        >
          <span className="font-medium">Thiết kế bởi</span>{" "}
          <span className="font-bold">Katec</span>
        </a>
      </div>
    </div>
  );
}

export default Footer;